import React from "react"
import { Modal } from "@mimber/ui-web"
import { LineItemForm } from "@/components/forms/LineItemForm"
import type { EditLineItemModalProps } from "./EditLineItemModal.types"

export const EditLineItemModal: React.FunctionComponent<
  EditLineItemModalProps
> = ({ invoiceUuid, lineItem, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Edit Line Item" {...modalProps}>
      {(close) => (
        <LineItemForm
          invoiceUuid={invoiceUuid}
          lineItem={lineItem}
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
          onCancel={close}
        />
      )}
    </Modal>
  )
}
